/*
  Note: If you are using this as a resize debouncer, maybe try using the ResizeObserver that is available under resize.js.
*/

const debounce = (eventType, callback) => {
  window.addEventListener(eventType, (evt) => {
    clearTimeout(window.eventComplete);
    window.eventComplete = setTimeout(() => {
      callback.apply();
    }, 250);
  });
};

export {
  debounce
}